import React from "react";

export const NotFoundPage = () => {
  return (
    <h1>404 Page</h1>
  );
 };